import * as React from "react";
import { useTranslation } from "react-i18next";
import RestoredArchivesCell from "data-lake/data-lake-overview/cells/RestoredArchivesCell";
import { DataLakeStreamRetrievableSizeCell } from "data-lake/components/RetrievableSizeCell";
import Routes from "routing/Routes";
import { HoverForHelp, Link } from "components/common";
import { COLUMN_WIDTH } from "components/common/EntityDataTable/Constants";
import DaysOfData from "./cells/DaysOfData";
const DeletedStreamTitle = () => {
  const { t } = useTranslation("enterprise_data_lake");
  return /* @__PURE__ */ React.createElement(React.Fragment, null, t("labels.deleted_stream"), /* @__PURE__ */ React.createElement(HoverForHelp, { title: t("labels.deleted_stream"), type: "error", displayLeftMargin: true, pullRight: false }, t("deleted_stream.help")));
};
const customColumnRenderers = {
  attributes: {
    stream_id: {
      renderCell: (_stream_id, dataLake) => dataLake.stream_title === null ? /* @__PURE__ */ React.createElement(DeletedStreamTitle, null) : /* @__PURE__ */ React.createElement(Link, { to: `${Routes.stream_view(dataLake.stream_id)}?segment=destinations` }, dataLake.stream_title),
      staticWidth: COLUMN_WIDTH.title
    },
    retrievable_stream_size: {
      renderCell: (_retrievableStreamSize, dataLake) => /* @__PURE__ */ React.createElement(DataLakeStreamRetrievableSizeCell, { streamId: dataLake.stream_id })
    },
    days_of_data: {
      renderCell: (_days_of_data, dataLake) => /* @__PURE__ */ React.createElement(DaysOfData, { dataLake }),
      staticWidth: "matchHeader",
      textAlign: "right"
    },
    message_count: {
      staticWidth: "matchHeader"
    },
    restored_indices: {
      renderCell: (_restored_indices, archive) => /* @__PURE__ */ React.createElement(RestoredArchivesCell, { archive }),
      staticWidth: "matchHeader",
      textAlign: "right"
    }
  }
};
export default customColumnRenderers;
